import { Component, OnInit, Input, OnDestroy, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder } from "@angular/forms";
import { Subscription, BehaviorSubject } from "rxjs";
import { map } from "rxjs/operators";
import { GroupService, GroupSearchSpec } from "../../../admin/services/group.service";
import { ContactStub } from "../../../admin/models/contact.model";
import { Group } from "../../../admin/models/group.model";
import { LunaClaimValues, LunaClaimTypes } from "../../../models/user-identity.model";


@Component({
    selector: 'reassign-issue',
    templateUrl: './reassign-issue.component.html',
    styleUrls: ['./reassign-issue.component.scss'],
    standalone: false
})
export class ReassignIssueComponent implements OnInit, OnDestroy {

    @Input() assignee: ContactStub;

    assignedId: string;

    @Output() assignedUser: EventEmitter<ContactStub> = new EventEmitter<ContactStub>();
    confirm: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    loading: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
    show: boolean = false;

    get assignText(): string {
        return (this.show) ? "Cancel Assignment" : "Assign Additional Reviewer";
    }

    formGroup: FormGroup = new FormGroup({});


    subscription: Subscription = new Subscription();
    @Output() throwError: EventEmitter<any> = new EventEmitter<any>();

    users: ContactStub[] = [];

    constructor(private builder: FormBuilder, private groupService: GroupService) { }

    ngOnInit() {
        this.assignedId = (this.assignee != null) ? this.assignee.id : "";
        this.formGroup = this.builder.group({ assignee: [this.assignedId, []] });
        const spec = {
            stubs: false,
            fullContactDetails: false,
            internal: true
        } as GroupSearchSpec;
        const group$ = this.groupService.get(spec).pipe(
            map((groups: Group[]) => {
                const applicable = groups.filter(g => g.permissions.find(p => p.value === LunaClaimValues.ManageIssues) != null);
                const contacts: ContactStub[] = [];
                applicable.forEach(a => {
                    a.users.forEach(u => {
                        if (contacts.find(c => c.id === u.id) == null) contacts.push(u);
                    });
                });
                return contacts;
            })
        ).subscribe(
            (contacts: ContactStub[]) => {
                this.users = contacts;
                this.loading.next(false);
            },
            (error) => { this.handleError(error); }
        );
        this.subscription.add(group$);
    }

    assignCancel(): void {
        if (this.show) {
            this.assignedUser.emit(null);
        }
        this.show = !this.show;
    }

    assignedUserChanged(evt: any): void {
        if (this.formGroup != null) {
            const ctrl = this.formGroup.get("assignee");
            if (ctrl != null) {
                this.assignedId = <string>ctrl.value;
                const user = this.users.find(u => u.id === this.assignedId);
                this.assignedUser.emit(user);
                this.confirm.next(true);
                setTimeout(() => { this.confirm.next(false); }, 2000);
            }
        }
    }

    handleError(err): void {
        this.loading.next(false);
        this.throwError.emit(err);
    }

    ngOnDestroy() {
        if (this.subscription) this.subscription.unsubscribe();
    }
}
